import { TippyConfig } from '@ngneat/helipopper';

export const tippyVariations: TippyConfig['variations'] = {
  tooltip: {
    theme: 'default',
    arrow: true,
    animation: 'shift-toward'
  },
  dailyRewardsTooltip: {
    theme: 'daily-rewards-tooltip',
    arrow: true,
    animation: 'shift-toward'
  },
  dropdown: {
    theme: 'dropdown',
    arrow: true,
    offset: [0, 10],
    animation: 'shift-toward',
    trigger: 'click',
    interactive: true
  },
  stickers: {
    theme: 'stickers',
    arrow: true,
    animation: 'shift-toward',
    interactive: true
  },
  chat: {
    theme: 'chat',
    arrow: true,
    animation: 'shift-toward',
    interactive: true,
    trigger: 'click'
  },
  profile: {
    theme: 'profile',
    arrow: false,
    animation: 'shift-away',
    interactive: true
  },
  notifications: {
    theme: 'notifications',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  dailyRewards: {
    theme: 'daily-rewards',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  buffsActive: {
    theme: 'buffs-active',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  quiz: {
    theme: 'quiz',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  piggy: {
    theme: 'piggy',
    arrow: true,
    offset: [0, 10],
    animation: 'shift-away',
    interactive: true
  },
  paymentDialogBonus: {
    theme: 'payment-dialog-bonus',
    arrow: true,
    animation: 'shift-away'
  },
  giftCodesInfo: {
    theme: 'gift-codes-info',
    arrow: true,
    animation: 'shift-away'
  },
  wagerBonus: {
    theme: 'wager-bonus',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  balanceMenu: {
    theme: 'balance-menu',
    arrow: false,
    animation: 'shift-away',
    interactive: true
  },
  toolbarGames: {
    theme: 'toolbar-games',
    arrow: false,
    offset: [0, 20],
    animation: 'shift-away',
    interactive: true
  },
  promoPage: {
    theme: 'promo-page',
    animation: 'shift-away',
    interactive: true
  },
  tournamentSkin: {
    theme: 'tournament-skin',
    animation: 'shift-away',
    interactive: true
  },
  withdraw: {
    theme: 'withdraw',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  tradeUrl: {
    theme: 'trade-url',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  headerGames: {
    theme: 'header-games',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  },
  lightGray: {
    theme: 'light-gray',
    arrow: true,
    animation: 'shift-away',
    interactive: true
  }
};
